import { gql } from '@apollo/client';

export default gql`
  mutation createMultiBrands($data: String) {
    createMultiBrands(data: $data) {
      ok
      message
      error
    }
  }
`;
